import Reveal from "@/components/Reveal";

export default function SectionHeading({ number, title, dark = false, testId }) {
  return (
    <Reveal>
      <div
        className={`flex items-end justify-between gap-6 border-b pb-6 md:pb-8 ${
          dark ? "border-paper/15" : "border-ink/15"
        }`}
      >
        <h2
          data-testid={testId}
          className="font-spartan font-extrabold uppercase leading-[0.9] display-type text-4xl sm:text-5xl lg:text-6xl"
        >
          {title}
        </h2>
        <span
          className={`font-spartan text-sm sm:text-base tracking-[0.35em] shrink-0 pb-1 ${
            dark ? "text-paper/50" : "text-ink/50"
          }`}
          aria-hidden="true"
        >
          {number}
        </span>
      </div>
    </Reveal>
  );
}
